import { render, staticRenderFns } from "./CustomerReminder.vue?vue&type=template&id=2987cf2a"
import script from "./CustomerReminder.vue?vue&type=script&lang=js"
export * from "./CustomerReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports